import { createFileRoute } from '@tanstack/react-router';

import { MicrosoftCallbackPage } from '@/features/login/ui/microsoft-callback-page';

export const Route = createFileRoute('/login/microsoft')({
  component: MicrosoftCallbackPage,
});
